<script>
import imgUrl from '@/assets/banner/banner.png';
import toImg from '@/assets/common/to.svg';

import index from "vuex";

export default {
  computed: {
    index() {
      return index
    }
  },
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
      uiMode: false,
      imgUrl: imgUrl,
      banner: [],
      bannerIndex: 0,
      theme: [],
      news: [],
      toImg: toImg,
      selectHead: {
        mask: false,
        list: []
      },
      footerImg: [],
      menuList: [
        {
          name: '产品分类',
          path: '/home',
          list: [{name: '匹克球', path: 'https://www.beesoul.net/?lm2/'}, {name: '匹克球拍', path: '/?lm1/'}, {name: '周边', path: '/?lm3/'}]
        },
        {name: '主题馆', path: 'https://www.beesoul.net//?anli/', list: []},
        {name: '新闻资讯', path: 'https://www.beesoul.net/home', list: [{name: '公司新闻', path: 'https://www.beesoul.net/?gongsi/'}, {name: '产品知识', path: 'https://www.beesoul.net/?zhishi/'}]},
        {name: '关于我们', path: 'https://www.beesoul.net/home', list: [{name: '公司介绍', path: 'https://www.beesoul.net/?jieshao/'}, {name: '发展历史', path: 'https://www.beesoul.net/?fazhan/'}]},
        {name: '联系我们', path: 'https://www.beesoul.net/?contact/', list: []},
      ],
      interOne: null,
      scrollState: false,
      moreMask: false,
    };
  },
  mounted() {
    this.getFlag();
    this.loadImages()
    // 添加事件监听
    // this.$el.addEventListener('scroll', this.handleScroll);

    // 监听滚动事件并加上节流
    this.interOne = setInterval(this.handleScroll, 200)

  },
  beforeDestroy() {
    // this.$el.removeEventListener('scroll', this.handleScroll);
    clearInterval(this.interOne)
  },
  methods: {
    // 监听滚动事件
    handleScroll() {
      if (this.$refs.scrollContainer.scrollTop > 40) {
        this.scrollState = true
      } else {
        this.scrollState = false
      }

    },
    chooseHeaderItem(e) {
      if(e.list.length===0){
        location.href = e.path;
        return
      }
      this.selectHead.mask = true
      this.selectHead.list = e.list

    },
    toPath(path){
      console.log(path)
      location.href = path
    },
    cancerHeader() {
      this.selectHead.mask = false
    },
    loadImages() {
      // 使用 require.context 来获取 images 文件夹下的所有图片
      // 第一个参数是文件夹路径
      // 第二个参数是是否查找子文件夹
      // 第三个参数是一个匹配文件的正则表达式
      const imgContext = require.context('@/assets/carousel', false, /\.png$/);

      imgContext.keys().forEach(key => {
        // 提取图片名称（去掉路径和文件后缀）
        const name = key.replace(/^\.\/|\.png$/g, '');
        // 将图片名称和 URL 一起存入数组
        this.banner.push({name: name, img: imgContext(key)});
      });

      const themeContext = require.context('@/assets/theme', false, /\.jpg$/);

      themeContext.keys().forEach(key => {
        // 提取图片名称（去掉路径和文件后缀）
        const name = key.replace(/^\.\/|\.jpg$/g, '');
        // 将图片名称和 URL 一起存入数组
        this.theme.push({name: name, img: themeContext(key)});
      });

      const newsContext = require.context('@/assets/news', false, /\.jpg$/);

      // imgContext.keys() 返回一个包含所有匹配文件的路径的数组
      newsContext.keys().forEach(key => {
        // imgContext(key) 返回匹配文件的模块导出，即图片的 URL
        this.news.push(newsContext(key));
        console.log()
      });

      const footerImgContext = require.context('@/assets/footer', false, /\.svg$/);

      // imgContext.keys() 返回一个包含所有匹配文件的路径的数组
      footerImgContext.keys().forEach(key => {
        // imgContext(key) 返回匹配文件的模块导出，即图片的 URL
        this.footerImg.push(footerImgContext(key));
        console.log(this.footerImg)
      });
    },
    getFlag() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      console.log(flag)
      if (!flag) {
        this.uiMode = true
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    changeBanner(e) {
      this.bannerIndex = e
    },
    chooseBanner(e) {
      this.bannerIndex = e
      this.$refs.bannerEl.setActiveItem(e)
    }
  }
}
</script>

<template>
  <div class="box" ref="scrollContainer">
    <div class="mask" v-if="moreMask">
      <div class="content">
        <div class="item" v-for="(item,index) in menuList" :key="index" :style="index===0?'margin-left: 0':''">
          {{ item.name }}
          <div class="bottom-line"></div>
        </div>
      </div>

    </div>
    <div class="header-mask" v-if="selectHead.mask">
      <div class="left">
        <div class="header-top">
          <div class="item" @click="chooseHeaderItem(item)" v-for="(item,index) in menuList" :key="index"
               :style="index===0?'margin-left: 0':''">
            {{ item.name }}
            <div class="bottom-line"></div>
          </div>

          <div class="cancer" @click="cancerHeader">
            ×
          </div>
        </div>
        <div class="header-body">
          <div class="item" v-for="(item,index) in selectHead.list" :key="index" @click="toPath(item.path)">
            <div class="icon">
              ➡
            </div>
            <div class="content">
              {{ item.name }}
            </div>

          </div>
        </div>
      </div>
      <div class="right">
        <el-image
            style="width: 100%; height: 100%"
            src="https://beesoul.net/static/upload/image/20240923/1727056908580002.png"
            fit="cover"></el-image>
      </div>

    </div>
    <div class="box-header" :class="scrollState?'box-header-scroll':''" v-if="uiMode">
      <div class="left" style="display: flex">
        <div class="item" @click="chooseHeaderItem(item)" v-for="(item,index) in menuList" :key="index"
             :style="index===0?'margin-left: 0':''">
          {{ item.name }}
          <div class="bottom-line"></div>
        </div>
      </div>

      <div class="logo" style="display: flex;justify-content: center;align-items: center">
        <el-image
            style="width: 100%; height: 20px"
            src="https://beesoul.net/static/upload/image/20240903/1725365702984557.png"
            fit="scale-down"></el-image>
      </div>
      <!--      <div class="item">-->
      <!--        <li class="el-icon-tickets"></li>-->
      <!--        <span style="margin-left: 5px">购物咨询</span>-->
      <!--        <div class="bottom-line"></div>-->
      <!--      </div>-->
      <!--      <div class="item">-->
      <!--        <li class="el-icon-user"></li>-->
      <!--        <span style="margin-left: 5px">登录/注册</span>-->
      <!--        <div class="bottom-line"></div>-->
      <!--      </div>-->
      <div class="push" style="font-size: 11px;line-height: 14px;width: 62px;padding: 6px;">
        预约试打
      </div>
    </div>

    <div class="box-header" :class="scrollState?'box-header-scroll':''" v-if="!uiMode"
         style="justify-content: space-between">
      <div class="expands" @click="moreMask = true">
        <li v-if="!moreMask" class="el-icon-s-fold" style="color: white"></li>
        <div style="color: white;font-size: 20px" v-if="moreMask" class="cancer" @click.stop="moreMask = false">
          ×
        </div>
      </div>
      <div class="logo" style="padding:0;display: flex;justify-content: center;align-items: center">
        <el-image
            style="width: 100%; height: 20px"
            src="https://beesoul.net/static/upload/image/20240903/1725365702984557.png"
            fit="scale-down"></el-image>
      </div>
      <div class="push" style="font-size: 11px;line-height: 14px;width: 62px;padding: 6px;">
        预约试打
      </div>
    </div>

    <div class="body">
      <div class="block">

        <div class="banner-detail">
          <el-image

              src="/assets/images/beesoul.png"
          ></el-image>

          <div class="push" style="margin-top: 40px;margin-left: 5px;">
            预约试打
          </div>

          <div class="progress-video">
            <div class="progress-item"></div>
          </div>
        </div>
        <el-carousel style="overflow: hidden" arrow="never" trigger="click" height="100vh" indicator-position="none"
                     :interval="30000">
          <el-carousel-item v-for="item in 1" :key="item">
            <div class="video-container">
              <video
                  src="/assets/video/top.mp4"
                  autoplay
                  playsinline
                  muted
                  loop
                  class="video"
                  :style="uiMode?'width: 100%;height: auto;':'width: auto;height: 100%'"
              ></video>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="region" style="background-color: white;height: auto">
        <div class="line" style="color: black">
          热门球拍产品展示
        </div>
        <div class="racket">
          <div class="item" v-for="(item,index) in banner" :key="index" :style="bannerIndex===index?'color: black':''"
               @click="chooseBanner(index)">
            {{ item.name }}
          </div>
        </div>
        <el-carousel ref="bannerEl" :initial-index="bannerIndex" @change="changeBanner"
                     style="overflow: hidden;margin-top: 40px" arrow="always" trigger="click" height="50vh"
                     indicator-position="none" :autoplay="false">
          <div class="images">
            <el-carousel-item v-for="(item,index) in banner" :key="index">
              <el-image
                  style="width: 300px; "
                  :src="item.img"
                  fit="scale-down"></el-image>
            </el-carousel-item>
          </div>

        </el-carousel>
      </div>
      <div class="region" style="background-color: rgb(242,243,237);height: 80vh">
        <div class="content">
          <el-image
              style="width: 100%; height: 100%"
              :src="imgUrl"
              fit="cover"></el-image>
          <div class="describe">
            <div class="line" style="font-weight: 600;font-size: 25px">
              Foka互联
            </div>
            <div class="line">
              提供线上线下无缝体验，尽享匹克球乐趣!
            </div>
            <div class="push" style="margin-top: 40px">
              了解更多
            </div>
          </div>
        </div>
      </div>
      <div class="region" style="background-color: rgb(242,243,237);height: auto;min-height: 100vh">
        <div class="line" style="color: black">
          品牌动态
        </div>

        <div class="show" v-if="uiMode">
          <div class="left">
            <div class="item">
              <el-image
                  style="width: 100%; height: 700px"
                  :src="news[0]"
                  fit="cover"></el-image>

              <div class="">
                Beesoul主题馆
              </div>
            </div>
            <div class="bottom">
              <div class="item" style="width: calc(50% - 20px)" v-for="(item,index) in news.slice(3,5)" :key="index">
                <el-image
                    style="width: 100%; height: 300px"
                    :src="item"
                    fit="cover"></el-image>

                <div class="">
                  Beesoul主题馆
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="item">
              <el-image
                  :style="uiMode?'width: 100%; height: 300px':'width: 100%; height: 100%'"
                  :src="news[1]"
                  fit="cover"></el-image>

              <div class="">
                Beesoul主题馆
              </div>
            </div>
            <div class="item">
              <el-image
                  :style="uiMode?'width: 100%; height: 700px':'width: 100%; height: 100%'"
                  :src="news[2]"
                  fit="cover"></el-image>

              <div class="">
                Beesoul主题馆
              </div>
            </div>
          </div>
        </div>
        <div class="show-phone" v-if="!uiMode">
          <div class="item" v-for="(item,index) in news" :key="index">
            <el-image
                style="width: 100%; height: 150px"
                :src="news[index]"
                fit="cover"></el-image>
            <!--            <div class="title">-->
            <!--              ET9-->
            <!--            </div>-->
            <div class="">
              Beesoul主题馆
            </div>
          </div>
        </div>
      </div>

      <div class="region" style="background-color: rgb(242,243,237);height: auto;min-height: 100vh" v-if="theme.length">

        <div class="show-two-phone" v-if="!uiMode">
          <div class="head">
            <div class="right" style="width: 100%">
              <el-image
                  style="width: 100%; height: auto"
                  :src="theme[1].img"
                  fit="cover"></el-image>
            </div>
            <div class="left" style="margin-top: 50px;width: 100%">


              <div class="name">
                Beesoul主题馆
              </div>

              <p class="describe">
                提供线上线下无缝体验，尽享匹克球乐趣。
              </p>
              <div class="push" style="color: black;border: black 1px solid">
                了解更多
              </div>
            </div>
          </div>
          <div class="bottom" style="overflow: scroll">
            <div class="item" :style="index===1?'width: 250px;':'width: 250px;margin-left: 10px'"
                 v-for="(item,index) in theme" :key="index" v-if="index!==1">
              <el-image
                  style="width: 250px; height: 210px"
                  :src="theme[index].img"
                  fit="contain"></el-image>

              <div class="">
                {{ item.name }} Beesoul主题馆
              </div>
            </div>
          </div>
        </div>
        <div class="show-two" v-if="uiMode">
          <div class="head">
            <div class="left">


              <div class="name">
                Beesoul主题馆
              </div>

              <p class="describe">
                提供线上线下无缝体验，尽享匹克球乐趣。
              </p>
              <div class="push" style="color: black;border: black 1px solid">
                了解更多
              </div>
            </div>
            <div class="right">
              <div class="item">
                <el-image
                    style="width: 100%; height: 700px"
                    :src="theme[1].img"
                    fit="cover"></el-image>

                <div class="">
                  德兴 Beesoul主题馆
                </div>
              </div>
            </div>
          </div>
          <div class="bottom" style="margin-top: 50px">
            <div class="item" style="width: calc(50% - 20px)" v-for="(item,index) in theme" :key="index"
                 v-if="index!==1">
              <el-image
                  style="width: calc(100% - 20px); height: 300px"
                  :src="theme[index].img"
                  fit="cover"></el-image>

              <div class="">
                {{ theme[index].name }} Beesoul主题馆
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="region" style="background-color: rgb(0,0,0)">
        <div class="content">
          <el-image
              style="width: 100%; height: 100%"
              :src="imgUrl"
              fit="cover"></el-image>
        </div>
      </div>
      <div class="region" v-if="uiMode"
           style="background-color: rgb(242,243,237);padding:60px 0 0 0;height: 400px;overflow: hidden">
        <div class="substance">
          <div class="left">
            <div class="title">
              下载FOKA
            </div>
            <div class="describe" style="margin-top: 30px">
              轻松报名匹克球赛事，享受便捷操作
            </div>
            <div class="describe">
              预约周边匹克球俱乐部，尽享运动乐趣
            </div>
            <div class="describe">
              分享运动体验，连接更多体育爱好者
            </div>
            <div class="push"
                 style="color: black;border: black 1px solid;margin-top: 30px;width: 120px;line-height: 25px;font-size: 15px;font-weight: 400">
              查看更多
            </div>
          </div>
          <div class="right">
            <el-image
                style="width: 100px; height: 100px"
                src="/assets/images/qrcode.png"
                fit="fill"></el-image>
            <div class="title" style="margin-top: 20px">
              即刻下载
            </div>
            <div class="describe" style="margin-top: 20px;font-size: 10px">
              开发者信息: 搏壹体育（广州）有限公司
            </div>
            <div class="describe" style="margin-top: 0;font-size: 10px">
              版本: v1.0.0
            </div>
            <div class="goto">
              <div class="item">
                <div class="name">隐私政策</div>
                <img :src="toImg" alt="">
              </div>
              <div class="item" style="margin-left: 10px">
                <div class="name">隐私政策</div>
                <img :src="toImg" alt="">
              </div>
            </div>

          </div>
          <div class="phone-img">
            <img src="/assets/images/WechatIMG319.jpg" alt="">
          </div>
        </div>
      </div>
      <div class="region" v-if="!uiMode"
           style="background-color: rgb(242,243,237);padding:60px 0 0 0;height: 500px;overflow: hidden">

        <div class="substance-phone">
          <div class="title">
            下载FOKA
          </div>
          <div class="describe" style="margin-top: 30px">
            轻松报名匹克球赛事，享受便捷操作
          </div>
          <div class="describe">
            预约周边匹克球俱乐部，尽享运动乐趣
          </div>
          <div class="describe">
            分享运动体验，连接更多体育爱好者
          </div>
          <div class="push"
               style="color: black;border: black 1px solid;margin-top: 30px;width: 120px;line-height: 25px;font-size: 15px;font-weight: 400">
            查看更多
          </div>


          <div class="describe" style="margin-top: 20px;font-size: 10px">
            开发者信息: 搏壹体育（广州）有限公司
          </div>
          <div class="describe" style="margin-top: 0;font-size: 10px">
            版本: v1.0.0
          </div>

          <img class="phone" src="/assets/images/WechatIMG319.jpg" alt="">

        </div>
      </div>
      <div class="footer" v-if="uiMode">
        <div class="left">
          <span style="font-weight: 600">Beesoul © 2024 &nbsp</span>
        </div>
        <div class="center">
          <div class="item" v-for="(item,index) in 4" :key="index">
            合作伙伴
          </div>
        </div>

        <div class="right">
          <div class="item" v-for="(item,index) in footerImg" :key="index">
            <img :src="footerImg[index]" alt="">
          </div>
        </div>
      </div>


      <div class="footer-phone" v-if="!uiMode">

        <div class="footer-line">
          <span style="font-weight: 600">Beesoul © 2024 &nbsp</span>
        </div>
        <div class="footer-line" v-for="(item,index) in 4" :key="index">
          合作伙伴
        </div>

        <div class="footer-bottom">
          <div class="item" :style="index===0?'margin-left: 0':''" v-for="(item,index) in footerImg" :key="index">
            <img :src="footerImg[index]" alt="">
          </div>
        </div>

        <div class="language">
          <div class="name">CN</div>
          <img src="/assets/images/icon-flag-cn-20210308.png" alt="">
        </div>


        <div class="record">
          <span style="font-weight: 600"> 2024 ©</span>
          <span style="font-weight: 400;color: rgba(0,0,0,0.2);margin-left: 13px">粤ICP备2024297910号-3</span>
        </div>
      </div>
    </div>


  </div>
</template>

<style scoped lang="scss">
/* 仅适用于WebKit浏览器 */
::-webkit-scrollbar {
  display: none;
}

.box {
  width: 100vw;
  color: black;
  height: 100vh;
  position: relative;
  //overflow: hidden;
  overflow-x: hidden;
  //overflow-y: scroll;
}

.mask {
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.9);
  width: 100vw;
  top: 0;
  left: 0;
  position: fixed;
  height: 100vh;

  .content {
    position: fixed;
    top: 10vh;
    left: 0;
    width: 90%;
    padding: 0 5%;
    height: 90vh;

    .item {
      margin-top: 40px;
      color: white;
      text-align: left;
    }
  }
}

.body {
  width: 100%;
  color: black;
  height: 100%;
  position: relative;
  //overflow: scroll;
}

//.el-dropdown-link {
//  cursor: pointer;
//  color: #fff;
//}
//.el-dropdown-menu{
//  margin-left: 10px;
//}
//.el-popper{
//  width: 300px;
//  text-align: center;
//}
//.el-dropdown-menu__item{
//
//}
.header-mask {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  //padding: 2px 5vw;
  .left {
    width: 40%;
    height: 100%;

    .header-top {
      top: 0;
      left: 0;
      width: 34%;
      padding: 2px 5%;
      margin-top: 15px;
      height: 40px;
      line-height: 40px;
      //background-color: rgba(255,255,255,0.5);
      display: flex;
      align-items: center;
      position: fixed;
      z-index: 99;

      .cancer {
        font-weight: 500;
        font-size: 25px;
        margin-left: auto;
        color: white;
        cursor: pointer;
      }

      .item {
        z-index: 99;
        margin-left: 30px;
        padding: 0 5px;
        height: 100%;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 12px;
        position: relative;
        font-weight: 300;

        .bottom-line {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;

        }
      }

      .item:hover {
        .bottom-line {
          border-bottom: #00dad2 1px solid;
        }

      }
    }

    .header-body {
      //background-color: #00dad2;
      top: 80px;
      color: white;
      left: 5vw;
      height: 100%;
      font-weight: 100;
      position: relative;

      .item {
        display: flex;
        align-items: center;
        width: 100%;
        height: 40px;
        cursor: pointer;

        .icon {
          color: red;
        }

        .content {
          width: 100%;
          text-align: left;
          height: 40px;
          line-height: 40px;
          font-weight: 100;
          font-size: 16px;
          margin-left: 5px;
        }

        .content:hover {
          height: 39px;
          border-bottom: #00dad2 1px solid;
        }
      }
    }
  }

  .right {
    width: 60%;
    height: 100%;
  }

}

.box-header-scroll:hover {
  padding: 17px 5%;
}

.box-header {
  top: 0;
  left: 0;
  width: 100%;
  padding: 17px 5%;
  //margin-top: 15px;
  height: 40px;
  line-height: 40px;
  //background-color: rgba(255,255,255,0.5);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 99;
  transition: 0.5s;

  .logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .item {
    z-index: 999;
    margin-left: 30px;
    padding: 0 5px;
    height: 100%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 12px;
    position: relative;
    font-weight: 300;

    .bottom-line {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;

    }
  }

  .item:hover {
    .bottom-line {
      border-bottom: #00dad2 1px solid;
    }

  }
}

.box-header-scroll {
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 2.5px 5%;
}

.footer-phone {
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .record {
    margin: 30px 0;
    font-size: 14px;
    font-weight: 700;
  }

  .footer-line {
    margin: 0 40px;
    font-size: 14px;
    cursor: pointer;
    display: block;
    font-weight: 700;
    line-height: 2;
    color: #000;
  }

  .language {
    padding: 5px 10px;
    border: rgba(0, 0, 0, 0.2) 1px solid;
    margin-top: 20px;
    display: flex;
    align-items: center;
    font-weight: 700;

    img {
      margin-left: 5px;
      width: 30px;
      height: 21px;
    }
  }

  .footer-bottom {
    display: flex;
    margin-top: 10px;
    justify-content: center;
    align-items: center;

    .item {
      margin-left: 20px;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.footer {
  padding: 30px 2.5vw;
  width: 100vw;
  //margin-left: 5vw;
  left: 0;
  font-weight: 400;
  font-size: 12px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {

  }

  .center {
    display: flex;
    align-items: center;

    .item {
      margin-left: 50px;
    }
  }

  .right {
    .item {
      margin-left: 20px;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.substance-phone {
  display: flex;
  padding-top: 30px;
  flex-direction: column;
  align-items: center;
  position: relative;

  .phone {
    width: 200px;
  }

  .title {
    font-size: 36px;
    font-weight: 300;
    line-height: 50px;
  }

  .describe {
    margin-top: 15px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.8);
  }

  .right {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .goto {
    margin-top: 15px;
    display: flex;
    align-items: center;

    .item {
      display: flex;
      font-size: 10px;
      align-items: center;

      img {
        margin-left: 5px;
        width: 15px;
        height: 15px;
      }
    }
  }
}

.substance {
  width: 60%;
  display: flex;
  text-align: left;
  position: relative;
  justify-content: space-between;

  .phone-img {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100px);

    img {
      width: 300px;
      height: auto;
    }
  }

  .title {
    font-size: 36px;
    font-weight: 300;
    line-height: 50px;
  }

  .describe {
    margin-top: 15px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.8);
  }

  .right {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .goto {
    margin-top: 15px;
    display: flex;
    align-items: center;

    .item {
      display: flex;
      font-size: 10px;
      align-items: center;

      img {
        margin-left: 5px;
        width: 15px;
        height: 15px;
      }
    }
  }
}

.line {
  font-size: 32px;
}

.show-phone {
  width: 80vw;
  margin-top: 10vh;
  height: auto;

  .item {
    text-align: left;
    width: 100%;
    color: black;
    font-size: 14px;
    margin-top: 10px;

    .title {
      font-weight: 600;
    }
  }
}

.show-two-phone {
  width: 80vw;
  //margin-top: 10vh;
  height: 1000px;
  text-align: left;

  .head {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .left {
      width: 30%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: left;

      .name {
        margin-top: 10px;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.5);
      }

      .describe {
        font-size: 32px;
        max-width: 330px;
      }
    }

    .right {
      width: calc(65% - 40px);
    }
  }

  .item {
    width: 100%;
    color: black;
    font-size: 14px;
    margin-top: 10px;

    .title {
      font-weight: 600;
    }
  }
}

.show-two {
  width: 80vw;
  //margin-top: 10vh;
  height: 1100px;
  text-align: left;

  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      width: 30%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 700px;
      text-align: left;

      .name {
        margin-top: 10px;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.5);
      }

      .describe {
        font-size: 32px;
        max-width: 330px;
      }
    }

    .right {
      width: 66.66667%;
      height: 700px;
    }
  }

  .item {
    width: 100%;
    color: black;
    font-size: 14px;
    margin-top: 10px;

    .title {
      font-weight: 600;
    }
  }
}

.bottom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.show {
  width: 80vw;
  margin-top: 10vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1100px;

  .left {
    width: calc(65% - 40px);
    height: 100%;
  }

  .right {
    width: 35%;
    height: 100%;
  }

  .item {
    text-align: left;
    width: 100%;
    color: black;
    font-size: 14px;
    margin-top: 10px;

    .title {
      font-weight: 600;
    }
  }
}

.images {
  width: 100vw;
  height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.region {
  width: 100%;
  height: 64vh;
  padding: 8vh 0;
  //overflow-y: scroll;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .racket {
    width: 80%;
    overflow: scroll;
    display: flex;
    align-items: center;
    margin-top: 20px;
    justify-content: center;

    .item {
      cursor: pointer;
      margin-left: 30px;
      font-size: 25px;
      color: rgba(0, 0, 0, 0.3);
    }
  }

  .content {
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .describe {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      flex-direction: column;
      align-items: center;
      color: white;
      display: flex;

      .line {
        margin-top: 20px;
      }
    }
  }
}

.block {
  width: 100%;
  height: 100vh;
  position: relative;

  .banner-detail {
    position: absolute;
    bottom: 100px;
    left: 5%;
    z-index: 98;

    .progress-video {
      margin-top: 100px;

      .progress-item {
        margin-left: 10px;
        width: 32px;
        height: 1px;
        background-color: rgba(255, 255, 255, 0.5);
      }
    }
  }
}

.push {
  color: white;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  text-align: center;
  padding: 8px;
  cursor: pointer;
  border: white solid 1px;
  width: 75px;
}

//.video-container {
//  width: 100vw;
//  height: 100vh;
//  overflow: hidden;
//  position: relative; /* 添加相对定位 */
//}
//
//.video {
//  width: auto;
//  height: 100%;
//  display: block;
//  position: absolute; /* 绝对定位使视频可以在容器内自由移动 */
//  left: 50%; /* 将视频向左移动50%的容器宽度 */
//  transform: translateX(-50%); /* 使用transform将视频向左移动自身宽度的50%，实现居中 */
//}
//
//.el-carousel__item:nth-child(2n) {
//  background-color: #99a9bf;
//}
//
//.el-carousel__item:nth-child(2n+1) {
//  background-color: #d3dce6;
//}
</style>